// src/pages/AdminDashboard.js
import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore"; // Firestore methods
import { signOut } from 'firebase/auth'; // Import signOut from Firebase auth
import { db, auth } from "../firebaseConfig"; // Firestore and auth references
import { TextField, Button, Container, Box, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // For navigation

const AdminDashboard = () => {
  const [title, setTitle] = useState('');
  const [shortDescription, setShortDescription] = useState('');
  const [fullContent, setFullContent] = useState('');
  const [image, setImage] = useState('');
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();

  const fetchArticles = async () => {
    const querySnapshot = await getDocs(collection(db, "articles"));
    const articlesArray = querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
    setArticles(articlesArray);
  };

  useEffect(() => {
    if (!auth.currentUser) {
      navigate('/admin/login');
    } else {
      fetchArticles();
    }
  }, [navigate]);

  const handleAddArticle = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "articles"), {
        title,
        shortDescription,
        fullContent,
        image,
        date: new Date().toLocaleDateString(),
      });
      fetchArticles();
      setTitle('');
      setShortDescription('');
      setFullContent('');
      setImage('');
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const handleDeleteArticle = async (id) => {
    try {
      await deleteDoc(doc(db, "articles", id));
      fetchArticles(); // Refresh the articles list after deletion
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/admin/login');
    } catch (error) {
      console.error("Error logging out: ", error);
    }
  };

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Admin Dashboard</Typography>
        <Button variant="outlined" color="secondary" onClick={handleLogout}>
          Logout
        </Button>
      </Box>
      <form onSubmit={handleAddArticle}>
        <TextField
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          fullWidth
          required
          margin="normal"
        />
        <TextField
          label="Short Description"
          value={shortDescription}
          onChange={(e) => setShortDescription(e.target.value)}
          fullWidth
          required
          margin="normal"
        />
        <TextField
          label="Full Content"
          value={fullContent}
          onChange={(e) => setFullContent(e.target.value)}
          fullWidth
          required
          margin="normal"
          multiline
          rows={4}
        />
        <TextField
          label="Image URL"
          value={image}
          onChange={(e) => setImage(e.target.value)}
          fullWidth
          required
          margin="normal"
        />
        <Button type="submit" variant="contained" color="primary">
          Add Article
        </Button>
      </form>

      <Box mt={4}>
        <Typography variant="h5">Existing Articles</Typography>
        <Grid container spacing={2}>
          {articles.map(article => (
            <Grid item key={article.id} xs={12} sm={6} md={4}>
              <Box border={1} padding={2} borderRadius={2}>
                <img src={article.image} alt={article.title} style={{ width: '100%' }} />
                <Typography variant="h6">{article.title}</Typography>
                <Typography>{article.shortDescription}</Typography>
                <Button
                  variant="text"
                  color="primary"
                  onClick={() => navigate(`/blog/${article.id}`)} // Correct navigation with useNavigate
                  >
                  Citește mai mult
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => handleDeleteArticle(article.id)}
                >
                  Delete
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default AdminDashboard;
